

























































































































































































































































































































































































import {
  defineComponent,
  ref,
  onMounted,
  onUpdated,
  useContext,
  useRoute,
} from '@nuxtjs/composition-api';
import { SfNotification } from '@storefront-ui/vue';
import HydrogenCountrySelect from '~/components/HydrogenCountrySelect.vue';
import HydrogenNewsletter from '~/components/HydrogenNewsletter.vue';
import SfBreadcrumbs from '~/components/Sf/SfBreadcrumbs.vue';
import { useGtm, useHydrogenContactForm } from '~/composables';
import {
  getHydrogenCountryLabel,
  hydrogenCountryOptions,
} from '~/constants/hydrogenCountryOptions';
import { getMetaInfo } from '~/helpers/getMetaInfo';
import { Breadcrumb } from '~/modules/catalog/types';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { usePageStore } from '~/stores/page';
import { assign, join, map, trimEnd } from 'lodash-es';

export default defineComponent({
  name: 'HydrogenGenerationContactUs',
  components: {
    HydrogenCountrySelect,
    HydrogenNewsletter,
    SfBreadcrumbs,
    SfNotification,
    ValidationObserver,
    ValidationProvider,
  },
  setup() {
    const pageStore = usePageStore();
    const route = useRoute();
    const { eventPageLoad } = useGtm();
    const { localePath, app: { i18n, $config } } = useContext();
    const heroImage = '/hydrogen/contact-us-desktop-xs.png';
    const pageTitle = i18n.t('Hydrogen generation contact us');
    const pageMetaData = ref({
      meta_title: join([pageTitle, $config.defaultMetaTitle], ' | '),
      meta_description: pageTitle,
      meta_keyword: pageTitle,
      pageTitle,
      metaDescription: pageTitle,
      pageUrl: trimEnd($config.baseUrl, '/') + route.value.path,
    });
    const leadSubSource = 'contactus';
    const breadcrumbs = ref<Breadcrumb[]>([]);
    const requestTypeOptions = [
      'General inquiry',
      'Request a quote',
      'Technical support',
    ];
    const relatedArticles = [
      {
        title: 'International H2 and Fuel Cell Vehicle Congress (FCVC) and exhibition 2026',
        date: '01 June 2026',
        description: 'Date event: June 2026 Location: Kunshan, China',
        image: 'https://bekaert.scene7.com/is/image/bekaert/shanghai-article-card-view:Hydrogen-Card-Dynamic-Images-1310',
        link: '/hydrogen-generation/knowledge-center/events/international-hydrogen-and-fuel-cell-vehicle-congress-and-exhibition-2026',
      },
      {
        title: 'Hydrogen Technology World Expo 2026',
        date: '13 February 2026',
        description: 'Date event: 20-22 October 2026 Location: Hamburg, Germany',
        image: 'https://bekaert.scene7.com/is/image/bekaert/iStock-1041150588_Hamburg:Hydrogen-Card-Dynamic-Images-1310',
        link: '/hydrogen-generation/knowledge-center/events/hydrogen-technology-world-expo-2026',
      },
      {
        title: 'World Hydrogen Summit & Exhibition',
        date: '13 February 2026',
        description: 'Date event: 19-21 May 2026 Location: Rotterdam, The Netherlands',
        image: 'https://bekaert.scene7.com/is/image/bekaert/Rotterdam:Hydrogen-Card-Dynamic-Images-1310',
        link: '/hydrogen-generation/knowledge-center/events/world-hydrogen-summit-and-exhibition',
      },
    ];
    const {
      checkMaxCharacters,
      communicationConsent,
      companyInfo,
      contactForm,
      eventCustomlinksInteracted,
      filterCharacters,
      form,
      isOpenNotification,
      isNewsletterSubmitting,
      isRecaptchaEnabled,
      isSubmitDisabled,
      isSubmitSuccess,
      isSubmitting,
      newsletterEmail,
      newsletterMessage,
      newsletterMessageType,
      notification,
      onNewsletterSubmit,
      onRecaptchaExpired,
      onRecaptchaSuccess,
      onSubmit,
      personalInfo,
      recaptchaError,
      recaptchaToken,
      requestType,
      resetForm,
      startNewInquiry,
      submitForm,
      telCheck,
    } = useHydrogenContactForm({
      formName: 'Hydrogen Generation Contact Us',
      subject: 'Hydrogen generation contact us',
      dynamicTitle: pageMetaData.value.meta_title,
      leadSubSource,
      maxCharacters: 512,
      requestTypeOptions,
      getInitialCompanyInfo: () => ({
        country: 'CN',
        city: '',
        postalCode: '',
      }),
      buildComment({ requestType, companyInfo, communicationConsent, form, i18n }) {
        const country = getHydrogenCountryLabel(companyInfo.country, i18n.t('China') as string);
        const messageParts = [
          `${i18n.t('Request type')}: ${i18n.t(requestType)}`,
          `${i18n.t('Country/Region')}: ${country}`,
          `${i18n.t('City')}: ${companyInfo.city}`,
          `${i18n.t('Zip/Postal Code')}: ${companyInfo.postalCode}`,
          `${i18n.t('Marketing updates')}: ${communicationConsent ? i18n.t('Yes') : i18n.t('No')}`,
          form.comment,
        ];

        return join(messageParts.filter(Boolean), '\n');
      },
    });

    onUpdated(() => {
      document.body.classList.remove('show-hero-img');
    });
    onMounted(() => {
      document.body.classList.remove('show-hero-img');
      breadcrumbs.value = [
        {
          text: i18n.t('Home') as string,
          link: localePath('/'),
        },
        {
          text: i18n.t('Contact Us') as string,
          link: '',
        },
      ];
      pageStore.$patch((state) => {
        state.pageData = assign(state.pageData, {
          pageName: pageTitle,
          pageTitle,
          pageCategory: join(map(breadcrumbs.value, (item) => item.text), '/'),
          breadCrumbs: map(breadcrumbs.value, (item) => item.text),
        });
      });
      eventPageLoad();
    });

    return {
      breadcrumbs,
      checkMaxCharacters,
      communicationConsent,
      companyInfo,
      contactForm,
      eventCustomlinksInteracted,
      filterCharacters,
      form,
      heroImage,
      isOpenNotification,
      isNewsletterSubmitting,
      isRecaptchaEnabled,
      isSubmitDisabled,
      isSubmitSuccess,
      isSubmitting,
      newsletterEmail,
      newsletterMessage,
      newsletterMessageType,
      notification,
      onNewsletterSubmit,
      onRecaptchaExpired,
      onRecaptchaSuccess,
      onSubmit,
      pageMetaData,
      personalInfo,
      hydrogenCountryOptions,
      recaptchaError,
      recaptchaToken,
      relatedArticles,
      requestType,
      requestTypeOptions,
      resetForm,
      startNewInquiry,
      submitForm,
      telCheck,
    };
  },
  head() {
    return getMetaInfo(this.pageMetaData);
  },
});
